import { styled, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { PieChart } from "react-minimal-pie-chart";

import Fitness from "../images/fitness_small.svg";
import theme from "../styles/theme";
import { Category } from "../types";
import { secondsToTime } from "../utils/timeHelpers";
import { GetSessionsType } from "./Profile.gql";
import { ChartContainer } from "./Profile.sc";

interface ChartProps {
    data: GetSessionsType;
}

const Chart: React.FunctionComponent<ChartProps> = ({ data }) => {
    const [selected, setSelected] = React.useState<number | undefined>();
    const { t } = useTranslation();

    const chartData = data?.sessions
        ? [
              { title: t(Category.Endurance), value: data.sessions.totalDurationEndurance, color: theme.colors.Endurance },
              { title: t(Category.Strength), value: data.sessions.totalDurationStrength, color: theme.colors.Strength },
              { title: t(Category.Mobility), value: data.sessions.totalDurationMobility, color: theme.colors.Mobility },
              { title: t(Category.Relaxation), value: data.sessions.totalDurationRelaxation, color: theme.colors.Relaxation },
              { title: t(Category.Coordination), value: data.sessions.totalDurationCoordination, color: theme.colors.Coordination },
              { title: t(Category.Ai), value: data.sessions.totalDurationAi, color: theme.colors.Ai },
          ]
        : [];

    return (
        <>
            <ChartContainer>
                <ImageContainer>
                    <StyledImage src={Fitness} />
                </ImageContainer>
                <PieChart
                    data={chartData}
                    onClick={(event, index) => {
                        setSelected(index === selected ? undefined : index);
                    }}
                    style={{ width: "70%", overflow: "visible" }}
                    segmentsStyle={{ transition: "stroke .3s", cursor: "pointer" }}
                    segmentsShift={(index) => (index === selected ? 3 : 0)}
                    label={({ x, y, dx, dy, dataEntry }) => (
                        <text
                            key={dataEntry.title}
                            x={x}
                            y={y}
                            dx={dx}
                            dy={dy}
                            dominantBaseline="central"
                            textAnchor="middle"
                            style={{
                                fontSize: "8px",
                                fill: "white",
                            }}
                        >
                            {Math.round(dataEntry.percentage) > 0 ? `${Math.round(dataEntry.percentage)}%` : ""}
                        </text>
                    )}
                    animate
                />
            </ChartContainer>
            <Typography textAlign="center" style={{ marginTop: 20, minHeight: 50 }} color={selected === undefined ? "lightgrey" : "black"}>
                {selected !== undefined ? (
                    <>
                        <b>{secondsToTime(chartData[selected].value)}</b> {t("minutes")} {chartData[selected].title}
                    </>
                ) : (
                    t("chart_click_info")
                )}
            </Typography>
        </>
    );
};

export default Chart;

const StyledImage = styled("img")`
    display: flex;
    width: 160%;
    margin-right: -20px;
`;

const ImageContainer = styled("div")`
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
